import QRCode from 'qrcode'

// ─── Helpers de formatação ────────────────────────────────────────────────────

function fmtDate (d) {
  if (!d) return ''
  const dt = new Date(d)
  if (isNaN(dt.getTime())) return ''
  return dt.toLocaleDateString('pt-BR', { timeZone: 'UTC' })
}

function fmtNum (v, dec = 3) {
  if (v == null || v === '') return ''
  return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: dec, maximumFractionDigits: dec })
}

function esc (str) {
  if (str == null) return ''
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

// ─── Tradução de status ───────────────────────────────────────────────────────

function traduzStatus (status) {
  switch (status) {
    case '0': return 'CANCELADO'
    case '1': return 'EM CADASTRO'
    case '2': return 'AGUARDANDO EMBARQUE'
    case '3': return 'EMBARCANDO'
    case '4': return 'FINALIZADO'
    default: return status || ''
  }
}

// ─── Estilo CSS ───────────────────────────────────────────────────────────────

function buildStyles () {
  return `<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 8pt;
    color: #1a1a1a;
    background: #fff;
    padding: 4mm;
  }
  @media print {
    @page { size: A4 portrait; margin: 12mm 18mm; }
    body { padding: 0; }
    .no-print { display: none !important; }
    .page-break { page-break-before: always; }
  }

  /* ─── CABEÇALHO DA EMPRESA ─── */
  .doc-header {
    display: grid;
    grid-template-columns: 1fr auto;
    border: 2px solid #1a3a5c;
    margin-bottom: 3px;
  }
  .empresa-block {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 7px 10px;
  }
  .empresa-logo img {
    max-height: 52px;
    max-width: 90px;
    object-fit: contain;
  }
  .empresa-info .nome {
    font-size: 10pt;
    font-weight: bold;
    color: #1a3a5c;
    line-height: 1.2;
  }
  .empresa-info .razao {
    font-size: 7.5pt;
    color: #444;
  }
  .empresa-info .detalhe {
    font-size: 7pt;
    color: #666;
    margin-top: 1px;
  }
  .doc-side {
    border-left: 2px solid #1a3a5c;
    background: #f0f5f9;
    padding: 7px 14px;
    text-align: right;
    min-width: 175px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1px;
  }
  .doc-titulo {
    font-size: 10pt;
    font-weight: bold;
    letter-spacing: 2px;
    color: #1a3a5c;
    line-height: 1;
  }
  .doc-numero {
    font-size: 20pt;
    font-weight: bold;
    color: #1a3a5c;
    line-height: 1.05;
  }
  .doc-data {
    font-size: 7.5pt;
    color: #333;
    margin-top: 2px;
  }
  .doc-situacao {
    display: inline-block;
    margin-top: 4px;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 6.5pt;
    font-weight: bold;
    background: #1a3a5c;
    color: #fff;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  /* ─── RÓTULO DE SEÇÃO ─── */
  .sec-label {
    background: #1a3a5c;
    color: #fff;
    padding: 2px 8px;
    font-size: 7.5pt;
    font-weight: bold;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  /* ─── BLOCO DE DADOS DA ORDEM ─── */
  .ordem-block {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    border: 1px solid #b0bec5;
    border-top: none;
    margin-bottom: 3px;
  }
  .ordem-col {
    padding: 5px 8px;
  }
  .ordem-col + .ordem-col {
    border-left: 1px solid #b0bec5;
  }
  .frow {
    display: flex;
    align-items: baseline;
    margin-bottom: 2px;
    line-height: 1.35;
  }
  .flabel {
    color: #666;
    font-size: 7pt;
    min-width: 78px;
    flex-shrink: 0;
  }
  .fval {
    font-weight: 600;
    flex: 1;
    word-break: break-word;
    font-size: 8pt;
  }
  .fval-sm { font-size: 7pt; font-weight: 500; }

  /* ─── BADGE DE AGRUPAMENTO ─── */
  .agrup-badge {
    display: inline-block;
    background: #e8f0f5;
    border: 1px solid #b0bec5;
    border-radius: 4px;
    padding: 1px 7px;
    font-size: 7pt;
    font-weight: bold;
    color: #1a3a5c;
    margin-bottom: 4px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /* ─── TABELA PRINCIPAL ─── */
  table.main-tbl {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 3px;
  }
  table.main-tbl thead th {
    background: #1a3a5c;
    color: #fff;
    padding: 3px 5px;
    border: 1px solid #8ba7bf;
    text-align: center;
    font-weight: bold;
    font-size: 7pt;
    white-space: nowrap;
  }
  table.main-tbl thead th.left { text-align: left; }
  table.main-tbl tbody td {
    border: 1px solid #cfd8dc;
    padding: 2px 5px;
    vertical-align: middle;
    font-size: 7.5pt;
  }
  table.main-tbl tbody tr:nth-child(even) td {
    background: #f6f9fc;
  }
  table.main-tbl tbody tr.total-row td {
    background: #1a3a5c !important;
    color: #fff;
    font-weight: bold;
    font-size: 8pt;
  }
  .r { text-align: right; }
  .c { text-align: center; }

  /* ─── TOTALIZADORES RODAPÉ ─── */
  .totais-section {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 3px;
  }
  .totais-box {
    border: 2px solid #1a3a5c;
    border-radius: 4px;
    overflow: hidden;
    min-width: 280px;
  }
  .totais-title {
    background: #1a3a5c;
    color: #fff;
    padding: 3px 10px;
    font-size: 7.5pt;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    text-align: center;
  }
  .totais-body {
    padding: 5px 10px;
    background: #f8fbff;
  }
  .tot-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 3px;
    font-size: 8pt;
  }
  .tot-label { color: #555; font-size: 7.5pt; }
  .tot-val { font-weight: 700; color: #1a3a5c; text-align: right; }
  .tot-separator {
    border-top: 1px dashed #b0bec5;
    margin: 4px 0;
  }
  .tot-count {
    font-size: 6.5pt;
    color: #888;
    text-align: right;
    margin-top: 3px;
  }

  /* ─── QR CODE ─── */
  .qr-section {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    border: 1px solid #b0bec5;
    border-top: none;
    padding: 5px 8px;
    margin-bottom: 3px;
  }
  .qr-img { flex-shrink: 0; }
  .qr-info {
    font-size: 6.5pt;
    color: #555;
    line-height: 1.5;
  }
  .qr-info strong { color: #1a3a5c; font-size: 7pt; }

  /* ─── ASSINATURAS ─── */
  .assinatura-section {
    display: grid;
    grid-template-columns: 1fr 30px 1fr 30px 1fr;
    gap: 0;
    margin-top: 6mm;
    margin-bottom: 4px;
    page-break-inside: avoid;
  }
  .assinatura-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .assinatura-linha {
    width: 100%;
    border-top: 1px solid #333;
    margin-bottom: 3px;
  }
  .assinatura-label {
    font-size: 7pt;
    color: #555;
    text-align: center;
  }
  .assinatura-sub {
    font-size: 6pt;
    color: #888;
    text-align: center;
  }

  /* ─── RODAPÉ ─── */
  .doc-footer {
    border-top: 1px solid #b0bec5;
    padding-top: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 6.5pt;
    color: #888;
    margin-top: 3px;
  }
  .doc-footer strong { color: #1a3a5c; }

  /* ─── BLOCO RESUMO ─── */
  .resumo-section {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    border: 1px solid #b0bec5;
    border-top: none;
    margin-bottom: 3px;
  }
  .resumo-item {
    padding: 5px 8px;
    text-align: center;
  }
  .resumo-item + .resumo-item {
    border-left: 1px solid #b0bec5;
  }
  .resumo-item .r-label {
    font-size: 6.5pt;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }
  .resumo-item .r-val {
    font-size: 12pt;
    font-weight: bold;
    color: #1a3a5c;
    line-height: 1.2;
  }
  .resumo-item .r-val small {
    font-size: 7pt;
    opacity: 0.7;
  }
</style>`
}

// ─── Cabeçalho da empresa ─────────────────────────────────────────────────────

function buildCompanyHeader (empresa, ordem) {
  const logoHtml = (empresa.OP_IMPRIME_LOGO === '1' && empresa.LOGO)
    ? `<div class="empresa-logo"><img src="data:image/png;base64,${empresa.LOGO}" alt="Logo" /></div>`
    : ''

  const nomeEmpresa = empresa.FANTASIA || empresa.TX_RAZAO_SOCIAL || 'CEC Frigo'
  const mostrarRazao = empresa.FANTASIA && empresa.TX_RAZAO_SOCIAL && empresa.FANTASIA !== empresa.TX_RAZAO_SOCIAL
  const statusLabel = traduzStatus(ordem.STATUS)

  return `
<div class="doc-header">
  <div class="empresa-block">
    ${logoHtml}
    <div class="empresa-info">
      <div class="nome">${esc(nomeEmpresa)}</div>
      ${mostrarRazao ? `<div class="razao">${esc(empresa.TX_RAZAO_SOCIAL)}</div>` : ''}
      ${empresa.ENDERECO ? `<div class="detalhe">${esc(empresa.ENDERECO)}</div>` : ''}
      <div class="detalhe">
        ${empresa.CNPJ ? 'CNPJ: ' + esc(empresa.CNPJ) : ''}
        ${empresa.IE ? ' | IE: ' + esc(empresa.IE) : ''}
        ${empresa.TELEFONE ? ' | Fone: ' + esc(empresa.TELEFONE) : ''}
      </div>
    </div>
  </div>
  <div class="doc-side">
    <div class="doc-titulo">ORDEM DE EXPEDIÇÃO</div>
    <div class="doc-numero">${esc(String(ordem.NUMERO || ''))}</div>
    <div class="doc-data">
      ${ordem.DATA ? 'Data: <b>' + fmtDate(ordem.DATA) + '</b>' : ''}
      ${ordem.DATA_CADASTRO ? ' | Cadastro: ' + fmtDate(ordem.DATA_CADASTRO) : ''}
    </div>
    <div><span class="doc-situacao">${esc(statusLabel)}</span></div>
  </div>
</div>`
}

// ─── Campo genérico ───────────────────────────────────────────────────────────

function campo (label, val, sm = false) {
  if (!val && val !== 0) return ''
  return `<div class="frow">
    <span class="flabel">${label}:</span>
    <span class="fval${sm ? ' fval-sm' : ''}">${esc(String(val))}</span>
  </div>`
}

// ─── Bloco de dados da ordem ──────────────────────────────────────────────────

function buildOrdemBlock (ordem) {
  return `
<div class="sec-label">Dados da Expedição</div>
<div class="ordem-block">
  <div class="ordem-col">
    ${campo('ID', ordem.ID)}
    ${campo('Sequência', ordem.NUMERO)}
    ${campo('Data Planejada', fmtDate(ordem.DATA))}
    ${campo('Data Cadastro', fmtDate(ordem.DATA_CADASTRO))}
    ${campo('Situação', traduzStatus(ordem.STATUS))}
  </div>
  <div class="ordem-col">
    ${campo('Motorista', ordem.NOME_MOTORISTA)}
    ${campo('Conferente', ordem.NOME_CONFERENTE)}
    ${campo('Placa', ordem.PLACA)}
    ${campo('Veículo', ordem.NOME_VEICULO)}
  </div>
  <div class="ordem-col">
    ${campo('Usuário', ordem.USUARIO_CADASTRO)}
    ${campo('Início Embarque', ordem.HORA_INICIO ? fmtDate(ordem.DATA_EMBARQUE) + ' ' + ordem.HORA_INICIO : '')}
    ${campo('Término Embarque', ordem.HORA_TERMINO)}
    ${campo('Observações', ordem.OBSERVACOES, true)}
  </div>
</div>`
}

// ─── Bloco de resumo rápido ───────────────────────────────────────────────────

function buildResumoRapido (dados, totalGeral) {
  const nPedidos = new Set(dados.map(d => d.SEQUENCIA || d.N_VENDA)).size || dados.length
  const nClientes = new Set(dados.map(d => d.COD_CLI || d.NOME_CLIENTE)).size
  const nProdutos = new Set(dados.map(d => d.COD_PRO || d.NOME_PRODUTO)).size

  return `
<div class="sec-label">Resumo do Carregamento</div>
<div class="resumo-section">
  <div class="resumo-item">
    <div class="r-label">Total Geral</div>
    <div class="r-val">${fmtNum(totalGeral.QUANT)} <small>KG</small></div>
  </div>
  <div class="resumo-item">
    <div class="r-label">Peças Embarcadas</div>
    <div class="r-val">${totalGeral.PECAS || 0}</div>
  </div>
  <div class="resumo-item">
    <div class="r-label">Peças Pedido</div>
    <div class="r-val">${totalGeral.PECAS_PEDIDO || 0}</div>
  </div>
  <div class="resumo-item">
    <div class="r-label">${nPedidos > 0 ? 'Pedidos' : (nProdutos > 0 ? 'Produtos' : 'Itens')}</div>
    <div class="r-val">${nPedidos > 1 ? nPedidos : (nProdutos > 1 ? nProdutos : dados.length)}</div>
  </div>
</div>`
}

// ─── Tabela principal de totalizados ─────────────────────────────────────────

function buildTabelaTotalizados (rows, tipoAgrupamento, totalGeral) {
  const agrupBadge = {
    'Produto': 'Por Produto',
    'Cliente': 'Por Cliente',
    'Vendedor': 'Por Vendedor',
    'Município': 'Por Município'
  }

  const tableRows = rows.map((row, idx) => `
    <tr>
      <td class="c" style="color:#888;font-size:6.5pt;">${idx + 1}</td>
      <td class="c">${esc(String(row.CODIGO || ''))}</td>
      <td>${esc(row.AGRUPAMENTO || '')}</td>
      <td class="r">${fmtNum(row.QUANT)}</td>
      <td class="r">${row.PECAS != null ? row.PECAS : ''}</td>
      <td class="r">${row.PECAS_PEDIDO != null ? row.PECAS_PEDIDO : ''}</td>
    </tr>`).join('')

  return `
<div class="sec-label" style="display:flex;justify-content:space-between;align-items:center;">
  <span>Totalizados</span>
  <span style="font-size:6.5pt;font-weight:normal;letter-spacing:0;text-transform:none;opacity:0.85;">
    Agrupamento: <strong>${esc(agrupBadge[tipoAgrupamento] || tipoAgrupamento)}</strong>
  </span>
</div>
<table class="main-tbl">
  <thead>
    <tr>
      <th style="width:24px">#</th>
      <th style="width:60px">CÓDIGO</th>
      <th class="left">DESCRIÇÃO</th>
      <th style="width:110px">QUANTIDADE (KG)</th>
      <th style="width:90px">PÇS EMBARCADAS</th>
      <th style="width:90px">PÇS PEDIDO</th>
    </tr>
  </thead>
  <tbody>
    ${tableRows}
    <tr class="total-row">
      <td colspan="3">TOTAL GERAL — ${rows.length} item(ns)</td>
      <td class="r">${fmtNum(totalGeral.QUANT)}</td>
      <td class="r">${totalGeral.PECAS}</td>
      <td class="r">${totalGeral.PECAS_PEDIDO}</td>
    </tr>
  </tbody>
</table>`
}

// ─── Bloco QR Code ────────────────────────────────────────────────────────────

function buildQrBlock (qrDataUrl, ordem, empresa) {
  if (!qrDataUrl) return ''
  return `
<div class="sec-label">Validação do Documento</div>
<div class="qr-section">
  <div class="qr-img">
    <img src="${qrDataUrl}" width="80" height="80" alt="QR Expedição" />
  </div>
  <div class="qr-info">
    <strong>Ordem de Expedição Nº ${esc(String(ordem.NUMERO || ''))}</strong> — ID: ${esc(String(ordem.ID || ''))}<br>
    <strong>Emissão:</strong> ${fmtDate(ordem.DATA)}<br>
    <strong>Empresa:</strong> ${esc(empresa.FANTASIA || empresa.TX_RAZAO_SOCIAL || '')}<br>
    <strong>Motorista:</strong> ${esc(ordem.NOME_MOTORISTA || '')}<br>
    <strong>Veículo / Placa:</strong> ${esc(ordem.NOME_VEICULO || '')} ${esc(ordem.PLACA || '')}<br>
    <strong>Situação:</strong> ${esc(traduzStatus(ordem.STATUS))}<br>
    <em style="font-size:5.5pt;color:#aaa">Escaneie o QR Code para validar este documento de expedição.</em>
  </div>
</div>`
}

// ─── Assinaturas ─────────────────────────────────────────────────────────────

function buildAssinaturas () {
  return `
<div class="assinatura-section">
  <div class="assinatura-box">
    <div class="assinatura-linha"></div>
    <div class="assinatura-label">Motorista / Entregador</div>
    <div class="assinatura-sub">Nome / CNH</div>
  </div>
  <div></div>
  <div class="assinatura-box">
    <div class="assinatura-linha"></div>
    <div class="assinatura-label">Conferente Responsável</div>
    <div class="assinatura-sub">Nome / Matrícula</div>
  </div>
  <div></div>
  <div class="assinatura-box">
    <div class="assinatura-linha"></div>
    <div class="assinatura-label">Supervisor / Aprovação</div>
    <div class="assinatura-sub">Data: ____/____/________</div>
  </div>
</div>`
}

// ─── Rodapé ───────────────────────────────────────────────────────────────────

function buildFooter (empresa) {
  const nomeEmpresa = empresa.FANTASIA || empresa.TX_RAZAO_SOCIAL || 'CEC Frigo'
  return `
<div class="doc-footer">
  <span><strong>${esc(nomeEmpresa)}</strong> — Sistema de Controle e Gestão</span>
  <span>Documento de Expedição</span>
  <span>Impresso: ${new Date().toLocaleString('pt-BR')}</span>
</div>`
}

// ─── Abre janela de impressão ─────────────────────────────────────────────────

function abrirJanelaImpressao (html) {
  const w = window.open('', '_blank')
  if (!w) return
  w.document.open('text/html', 'replace')
  w.document.write(html)
  w.document.close()
  w.focus()
}

// ─── Função principal exportada ───────────────────────────────────────────────

/**
 * Imprime o relatório rico de totalizados da Ordem de Expedição.
 *
 * @param {Object} opts
 * @param {Object}   opts.ordem          - Registro da ordem (ID, NUMERO, STATUS, DATA, PLACA, etc.)
 * @param {Array}    opts.rows           - Linhas totalizadas já agrupadas (CODIGO, AGRUPAMENTO, QUANT, PECAS, PECAS_PEDIDO)
 * @param {Object}   opts.totalGeral     - { QUANT, PECAS, PECAS_PEDIDO }
 * @param {string}   opts.tipoAgrupamento - Ex: 'Produto', 'Cliente', 'Vendedor', 'Município'
 * @param {string}   [opts.nomeMotorista]
 * @param {string}   [opts.nomeConferente]
 * @param {string}   [opts.nomeVeiculo]
 * @param {Array}    [opts.dadosDetalhados] - Array bruto para calcular resumo rápido
 * @param {Object}   [opts.empresa]      - Dados da empresa { FANTASIA, TX_RAZAO_SOCIAL, CNPJ, IE, ENDERECO, TELEFONE, LOGO }
 */
export async function imprimirRelatorioExpedicao ({
  ordem,
  rows,
  totalGeral,
  tipoAgrupamento,
  nomeMotorista,
  nomeConferente,
  nomeVeiculo,
  dadosDetalhados = [],
  empresa = {}
}) {
  // Enriquece o objeto ordem com nomes resolvidos
  const ordemEnriquecida = {
    ...ordem,
    NOME_MOTORISTA: nomeMotorista || ordem.NOME_MOTORISTA || '',
    NOME_CONFERENTE: nomeConferente || ordem.NOME_CONFERENTE || '',
    NOME_VEICULO: nomeVeiculo || ordem.NOME_VEICULO || ''
  }

  // QR Code
  const qrText = [
    `EXPEDICAO: ${ordemEnriquecida.NUMERO || ordemEnriquecida.ID}`,
    `DATA: ${fmtDate(ordemEnriquecida.DATA)}`,
    `MOTORISTA: ${ordemEnriquecida.NOME_MOTORISTA}`,
    ordemEnriquecida.PLACA ? `PLACA: ${ordemEnriquecida.PLACA}` : '',
    `TOTAL KG: ${fmtNum(totalGeral.QUANT)}`,
    `PECAS: ${totalGeral.PECAS || 0}`,
    `SITUACAO: ${traduzStatus(ordemEnriquecida.STATUS)}`
  ].filter(Boolean).join('\n')

  let qrDataUrl = null
  try {
    qrDataUrl = await QRCode.toDataURL(qrText, { width: 160, margin: 1, errorCorrectionLevel: 'M' })
  } catch (e) {
    console.warn('QR Code não gerado:', e)
  }

  const titulo = `Expedicao_${ordemEnriquecida.NUMERO || ordemEnriquecida.ID}`

  const html = `<!doctype html>
<html>
<head>
  <meta charset="utf-8">
  <title>${esc(titulo)}</title>
  ${buildStyles()}
</head>
<body>
  ${buildCompanyHeader(empresa, ordemEnriquecida)}
  ${buildOrdemBlock(ordemEnriquecida)}
  ${buildResumoRapido(dadosDetalhados, totalGeral)}
  ${buildTabelaTotalizados(rows, tipoAgrupamento, totalGeral)}
  ${buildQrBlock(qrDataUrl, ordemEnriquecida, empresa)}
  ${buildAssinaturas()}
  ${buildFooter(empresa)}
  <script>
    window.addEventListener('load', function () {
      setTimeout(function () { window.print(); }, 400);
    });
  <\/script>
</body>
</html>`

  abrirJanelaImpressao(html)
}



// WEBPACK FOOTER //
// ./src/views/expedicao/ordemexpedicao/OrdemExpedicaoRelatorio.js